
export default class LocationSelector{

	constructor() {

		this.bindUIActions();

	}

	bindUIActions() {
		
		let selectLocation = () => {
			let $selectedLocation = $('#location-selector option').filter(":selected").val();

			let $locations = $('div[data-location-id]');

			let $locationsArray = $locations.toArray();

			$locationsArray.forEach((loc) => {

				if(loc.getAttribute('data-location-id') == $selectedLocation) {
					loc.classList.remove('hidden');
				} else {
					loc.classList.add('hidden');
				}
			});
			
		}

		let onSelectChange = function() {
			selectLocation();
			$('.js-default-loc').addClass('hidden');
		}

		$('#location-selector').change((onSelectChange));

	}
}

new LocationSelector();